export default {
    notifiedThryvMigratedUsers: [],
};
